"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLayout = resolveLayout;
exports.positionForRatio = positionForRatio;
function parseAnchor(anchor) {
    if (anchor === 'center')
        return { v: 'middle', h: 'center' };
    const [v, h] = anchor.split('-');
    return { v, h };
}
/**
 * Resolve a layer's position against a canvas. A layer with no position is full-frame. Element size
 * is optional (`widthPct`/`heightPct`); centering uses CSS translate so the element's own size is
 * respected without measuring it. Margin insets from the anchored edge (% of the smaller canvas
 * dimension); offsets are fine nudges (% of canvas width/height) applied as a transform.
 */
function resolveLayout(position, canvas) {
    if (!position)
        return { fullscreen: true };
    const { anchor, marginPct = 0, offsetXPct = 0, offsetYPct = 0, widthPct, heightPct } = position;
    const { v, h } = parseAnchor(anchor);
    const marginPx = (Math.min(canvas.width, canvas.height) * marginPct) / 100;
    const offsetXPx = (canvas.width * offsetXPct) / 100;
    const offsetYPx = (canvas.height * offsetYPct) / 100;
    const style = { position: 'absolute' };
    // Horizontal anchor → which edge to pin (center pins left:50% and is pulled back by translate).
    if (h === 'left')
        style.left = marginPx;
    else if (h === 'right')
        style.right = marginPx;
    else
        style.left = '50%';
    // Vertical anchor.
    if (v === 'top')
        style.top = marginPx;
    else if (v === 'bottom')
        style.bottom = marginPx;
    else
        style.top = '50%';
    // Centering pull-back (only for centered axes) composed with the fine nudge offsets, one transform.
    const tx = h === 'center' ? -50 : 0;
    const ty = v === 'middle' ? -50 : 0;
    if (tx !== 0 || ty !== 0 || offsetXPx !== 0 || offsetYPx !== 0) {
        style.transform = `translate(calc(${tx}% + ${offsetXPx}px), calc(${ty}% + ${offsetYPx}px))`;
    }
    if (widthPct != null)
        style.width = (canvas.width * widthPct) / 100;
    if (heightPct != null)
        style.height = (canvas.height * heightPct) / 100;
    return { fullscreen: false, style };
}
/** Merge a per-aspect-ratio override (if any) onto the base position for a given ratio key. */
function positionForRatio(basePosition, overrides, ratioKey) {
    const override = overrides?.[ratioKey];
    if (!basePosition || !override)
        return basePosition;
    return { ...basePosition, ...override };
}
